import copy from './copy';
import watermark from './watermark';
import permission from './permission';
import dialogDrag from './dialogDrag';
import drag from './drag';
import dragDialog from './dragDialog';
import knowledge from './knowledge';
import resize from './resize';
import focus from './focus';

const directives = {
	copy,
	watermark,
	permission,
	dialogDrag,
	drag,
	dragDialog,
	knowledge,
	resize,
	focus
};

export default {
	install(Vue) {
		Object.keys(directives).forEach((key) => {
			Vue.directive(key, directives[key]);
		})
	}
};